import React, { ReactNode } from 'react'
import { CSSTransition } from 'react-transition-group'

const DEFAULT_TIMEOUT = 300

interface PanelTransitionWrapperProps {
  children?: ReactNode
  enter: boolean
  timeout?: number
}

function PanelTransitionWrapper({
  children,
  timeout = DEFAULT_TIMEOUT,
  enter,
}: PanelTransitionWrapperProps) {
  return (
    <CSSTransition
      classNames="transition-project-switch-panel"
      timeout={timeout}
      in={enter}
      unmountOnExit
      mountOnEnter
    >
      {children}
    </CSSTransition>
  )
}

export default PanelTransitionWrapper
